import React, {useEffect} from 'react';
import {useEditFundRepresentativeForm} from '../../model';
import {ActionModal, ErrorModal, FormInput, useErrorHandler} from '../../../../shared';
import {useParams} from 'react-router';
import {FundRepresentativeModel} from '../../../../entities';

interface EditFundRepresentativeModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  representative?: FundRepresentativeModel;
}

export const EditFundRepresentativeModal = ({open, setOpen, representative}: EditFundRepresentativeModalProps) => {
  const params = useParams();

  const {isErrorModalOpen, errorInfo, handleError, handleClose} = useErrorHandler({
    resourceName: 'Представитель Фонда',
    title: 'Ошибка при редактировании представителя фонда',
  });

  const {values, errors, touched, handleChange, handleBlur, isLoading, submitError, resetForm, submitForm} =
    useEditFundRepresentativeForm({setOpen, representativeId: params.id ?? '', representative});

  useEffect(() => {
    if (submitError) {
      handleError(submitError);
    }
  }, [submitError, handleError]);

  return (
    <>
      <ActionModal
        open={open}
        onClose={() => setOpen(false)}
        setOpen={() => setOpen(false)}
        resetForm={resetForm}
        submitForm={submitForm}
        isLoading={isLoading}
        size={'m'}
        buttonsSize={'l'}
        caption={'Редактирование'}
        textButtonApply={'Сохранить'}
        textButtonCancel={'Отменить'}>
        <FormInput
          label="Display name"
          placeholder="Имя"
          name="displayName"
          value={values.displayName}
          onChange={handleChange}
          onBlur={handleBlur}
          error={touched.displayName && errors.displayName}
        />
      </ActionModal>
      <ErrorModal open={isErrorModalOpen} onClose={handleClose} title={errorInfo.title} message={errorInfo.message} />
    </>
  );
};
